// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>13</span>&nbsp;&nbsp;Surely, the righteous will give thanks to your name,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and the upright shall dwell in your presence.<br> </p> </div></div>";
// Exports
module.exports = code;